import {
  Advance,
  AdvanceType,
  Charge,
  EscrowAdvanceConfig,
  Fee,
  StandardAdvanceConfig,
} from '@willow/graphql-iso/src/app';

export function isFee(item: Charge): item is Fee {
  return item.__typename === 'Fee';
}

export function isAdvance(item: Charge): item is Advance {
  return item.__typename === 'Advance';
}

export function isEscrowAdvance(item: Charge): item is Advance & { advanceConfig: EscrowAdvanceConfig } {
  return isAdvance(item) && item.advanceConfig?.advanceType === AdvanceType.Escrow;
}

export function isCorporateAdvance(item: Charge): item is Advance & { advanceConfig: StandardAdvanceConfig } {
  return isAdvance(item) && item.advanceConfig?.advanceType === AdvanceType.Corporate;
}

export function isStandardAdvanceConfig(
  config: StandardAdvanceConfig | EscrowAdvanceConfig | null | undefined,
): config is StandardAdvanceConfig {
  return config?.__typename === 'StandardAdvanceConfig';
}
